import { useCallback } from 'react'
import { useCheckoutUrl } from './useCheckoutUrl'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
  }
}

export function useAddToCart() {
  const checkoutUrl = useCheckoutUrl()

  const handleAddToCart = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()

      // Fire Meta Pixel AddToCart event if fbq is available
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', {
          content_ids: ['52738305032303'],
          content_type: 'product',
          value: 17.99,
          currency: 'USD',
        })
      }

      // Wait 300ms for the pixel to fire, then redirect in same tab
      setTimeout(() => {
        window.location.href = checkoutUrl
      }, 300)
    },
    [checkoutUrl],
  )

  return { checkoutUrl, handleAddToCart }
}
